import _activities from './activities';
import _calendarEvents from './calendar-events';
import _duties from './duties';
import _groups from './groups';
import _person from './persons';
import _resources from './resources';
import _rooms from './rooms';
import _syllabuses from './syllabuses';

export default class {
  static activities     = _activities;
  static calendarEvents = _calendarEvents;
  static duties         = _duties;
  static groups         = _groups;
  static persons        = _person;
  static resources      = _resources;
  static rooms          = _rooms;
  static syllabuses     = _syllabuses;
}